<div class="check-in-signature">
  <section>
    <info-page-header label="Check-In" sublabel="Adulto"></info-page-header>
    <div class="check-in-signature-content">
      <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        @if (showEmailField()) {
          <div class="form__field">
            <label for="email">Email</label>
            <input id="email" type="email" formControlName="email" [class.is-invalid]="isFieldInvalid('email')" translate="no" data-wg-notranslate/>
            @if (isFieldInvalid('email')) {
              <small class="form__error">
                {{ form.get('email')?.hasError('required') ? 'Este campo es obligatorio.' : 'Introduce un email válido.' }}
              </small>
            }
          </div>
        }

        <!-- Firma -->
        <app-signature-pad #signaturePad data-testid="signature-pad"></app-signature-pad>

        <!-- Toggles -->
        <label class="toggle">
          <input type="checkbox" formControlName="aceptaPrivacidad"/>
          <span class="toggle__switch" data-testid="accept-privacy-toggle"></span>
          <span class="toggle__text" data-testid="accept-privacy-text">
          He leído y doy mi consentimiento<br/>
            a la <a routerLink="/privacy-policy" class="toggle__link" (click)="storeEmail()">Política de Privacidad</a>
        </span>
        </label>

        <label class="toggle"  *ngIf="contractReadRequired()">
          <input type="checkbox" formControlName="aceptaCondiciones"/>
          <span class="toggle__switch" data-testid="accept-contract-toggle"></span>
          <span class="toggle__text" data-testid="accept-contract-text">
          He leído y acepto las<br/>
            <button
              *ngIf="contractUrl as url"
              type="button"
              class="toggle__link toggle__link--button"
              (click)="onContractClick(url, $event)">
              Condiciones del Contrato
            </button>
        </span>
        </label>

        <!-- Botón principal -->
        <button
          type="submit"
          class="primary-btn"
          [disabled]="form.invalid || loading()"
          data-testid="check-in-signature-submit"
        >
          Finalizar Check-in
        </button>

        <p class="primary-btn__helper">
          Al pulsar en “Finalizar Check-in”, autorizas a que tu firma se plasme en el parte de
          viajeros y contrato de arrendamiento.
        </p>
      </form>
    </div>
  </section>
</div>
